import Navbar from "./components/Navbar";
import HeroSection from "./components/Header";
import About from "./components/About";
import Products from "./components/Products";
import Contact from "./components/Contact";

export default function Home() {
  return (
    <main className="bg-[#0a0a0a] min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <About />
      <Products />
      <Contact />
    </main>
  );
}
